import { Rhino } from '@ccmn/rhino';
import { useStore } from 'src/hooks';

let rhino: Rhino | null = null;

function useRhino() {
    const ctx = useStore();
    if (rhino === null) {
        rhino = new Rhino({
            TOKEN: async () => {
                return ctx.user.token.value || '';
            },
            BASE: '/rhino',
            WITH_CREDENTIALS: true,
            CREDENTIALS: 'include',
        });
    }
    return rhino;
}

export { useRhino };
